import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import Select from "react-select";
import $ from "jquery";
import "daterangepicker/daterangepicker.js";
import "daterangepicker/daterangepicker.css";
import moment from "moment/src/moment";
import VisibilitySensor from "react-visibility-sensor/visibility-sensor";

import SpinLoading from "../../shared/spin_loading";
import NearestTerm from "./nearest_term";
import "../../../packs/translations";
import Configuration from "../../configuration/configuration";
import { initPopover } from "../../../packs/libs";

I18n.locale = $("html").attr("lang");
const token = document.querySelectorAll('[name="csrf-token"]')[0].content;

const HotelCalculationList = (props) => {
  const [isLoad, setIsLoad] = useState(false);
  const [wasVisible, setWasVisible] = useState(false);
  const [nearestTerms, setNearestTerms] = useState([]);
  const [towns, setTowns] = useState([]);
  const [mealTypes, setMealTypes] = useState([]);

  const [adults, setAdults] = useState(props.adults);
  const [children, setChildren] = useState(props.children);
  const [rooms, setRooms] = useState(props.rooms);
  const [selectedTown, setSelectedTown] = useState();
  const [selectedMealType, setSelectedMealType] = useState();
  const [totalPrice, setTotalPrice] = useState(props.total_price);
  const [returnRoute, setReturnRoute] = useState(props.return_route);
  const [dateStart, setDateStart] = useState("");
  const [dateEnd, setDateEnd] = useState("");
  const [dateChange, setDateChange] = useState("");
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [setTownId, setSetTownId] = useState(!!props.town_id);
  const [setMealType, setSetMealType] = useState(!!props.meal_type);

  useEffect(() => {
    if (props.town_id) {
      setSetTownId(true);
    }
    if (props.meal_type) {
      setSetMealType(true);
    }
  }, [props.town_id, props.meal_type]);

  const initDateRangePicker = () => {
    let rangePicker = $(".daterange");
    rangePicker.daterangepicker({
      autoUpdateInput: false,
      showDropdowns: true,
      opens: "center",
      minDate: moment(new Date()).add(1, "days"),
      maxDate: moment(new Date()).add(1, "years").endOf("year"),
      locale: {
        format: "DD.MM.YYYY",
        applyLabel: `${I18n.t("js.filter.choose")}`,
        cancelLabel: `${I18n.t("js.filter.cancel")}`,
        daysOfWeek: I18n.t("js.days_of_week"),
        monthNames: I18n.t("js.month_names"),
        firstDay: 1,
      },
    });

    // show labels for both tables
    rangePicker.on("show.daterangepicker", function () {
      $(".drp-calendar.left .table-condensed thead").prepend(
        `<tr><th colspan="99">${I18n.t(
          "js.filter.terms_date_start_gt"
        )}</th></tr>`
      );
      $(".drp-calendar.right .table-condensed thead").prepend(
        `<tr><th colspan="99">${I18n.t(
          "js.filter.terms_date_end_lt"
        )}</th></tr>`
      );
    });

    rangePicker.on("cancel.daterangepicker", function (ev, picker) {
      rangePicker.val("");
      setDateStart("");
      setDateEnd("");
      setDateChange("");
    });

    rangePicker.on("apply.daterangepicker", function (ev, picker) {
      const newVal =
        picker.startDate.format("DD.MM.YYYY") +
        " - " +
        picker.endDate.format("DD.MM.YYYY");
      $(this).val(newVal);
      setDateStart(picker.startDate.format("DD.MM.YYYY"));
      setDateEnd(picker.endDate.format("DD.MM.YYYY"));
      setDateChange(newVal);
    });
  };

  const loadTowns = () => {
    axios
      .get("/api/nearest_terms/towns", {
        params: {
          authenticity_token: token,
          term_id: props.term_id,
          ids: nearestTerms.map((term) => term.id),
          adults: adults,
          children: children,
          rooms: rooms,
          returnRoute: returnRoute,
        },
      })
      .then((response) => {
        const data = response.data.map((item) => ({
          value: item.id,
          label: item.display_name,
        }));

        setTowns(data);

        if (setTownId) {
          setSelectedTown(
            data.filter((item) => {
              return item.value === props.town_id;
            })[0]
          );
          setSetTownId(false);
        }
      })
      .catch((error) => {});
  };

  const loadMealTypes = () => {
    axios
      .get("/api/nearest_terms/meal_types", {
        params: {
          authenticity_token: token,
          ids: nearestTerms.map((term) => term.id),
        },
      })
      .then((response) => {
        const data = response.data.map((item) => ({
          value: item.id,
          label: item.display_name,
        }));
        setMealTypes(data);

        if (setMealType) {
          const meal = Array.isArray(props.meal_type)
            ? parseInt(props.meal_type[0])
            : parseInt(props.meal_type);
          setSelectedMealType(
            data.filter((item) => {
              return item.value === meal;
            })
          );
          setSetMealType(false);
        }
      });
  };

  useEffect(() => {
    if (isLoad) {
      loadTowns();
      loadMealTypes();
      initDateRangePicker();
    }
  }, [isLoad]);

  useEffect(() => {
    if (wasVisible) {
      setIsLoad(false);

      const meal = selectedMealType
        ? [selectedMealType.value]
        : setMealType && props.meal_type
        ? props.meal_type
        : "";
      const townId = selectedTown
        ? selectedTown.value
        : setTownId && props.town_id
        ? props.town_id
        : "";

      const town = towns?.find((item) => item.value == townId)?.value;

      const params = {
        authenticity_token: token,
        page: page,
        sort: "terms.date_start asc",
        town_id: town,
        daterange: "",
        rooms: rooms,
        adults: adults,
        children: children,
        total_price: totalPrice ? "1" : "0",
        return_route: returnRoute ? "1" : "0",
        product_id: props.product_slug,
        hotel_id: props.hotel_slug,
        term_id: props.term_id,
        hid: props.hotel_id,
        query: {
          date_start_gteq: dateStart,
          date_start_lteq: dateEnd,
          term_routes_route_from_id_in: town,
          term_meals_meal_type_id_in: meal,
        },
      };

      axios
        .get(`${props.hotel_path}.json`, {
          params: params,
        })
        .then((response) => {
          setTotalCount(response.data.total_count);
          setNearestTerms(response.data.nearest_terms);
          setIsLoad(true);
          initPopover();
        })
        .catch((error) => {
          console.log(error.message);
        });
    }
  }, [
    rooms,
    adults,
    children,
    page,
    selectedTown,
    selectedMealType,
    totalPrice,
    returnRoute,
    dateChange,
    wasVisible,
  ]);

  const moveToTop = () => {
    const elem = $("#terms_form");
    if (elem) {
      $("html, body").animate(
        {
          scrollTop: elem.offset().top,
        },
        500
      );
    }
  };

  return (
    <VisibilitySensor
      scrollCheck={true}
      partialVisibility={true}
      onChange={(visible) => {
        if (visible && !wasVisible) {
          setWasVisible(true);
        }
      }}
    >
      <React.Fragment>
        <div className="filter filter--primary">
          <form id="terms_form">
            <div className="filter__wrap">
              <div className="form-row">
                <div className="form-group col-md-6 col-lg-3">
                  <label htmlFor="">{I18n.t("js.show_tour.labels.when")}</label>
                  <input
                    name="daterange"
                    id="daterange"
                    className="form-control filter-input daterange"
                    autoComplete="off"
                    placeholder={I18n.t("js.show_tour.labels.select_date")}
                    style={{ minHeight: "39px", height: "39px" }}
                  />
                </div>
                <div className="form-group col-md-6 col-lg-3">
                  <label htmlFor="">{I18n.t("js.show_tour.labels.town")}</label>
                  <div style={divStyle}>
                    <Select
                      options={towns}
                      value={selectedTown}
                      placeholder={I18n.t("js.choose")}
                      onChange={(option) => {
                        setSelectedTown(option);
                      }}
                      styles={customSelectStyles}
                      isClearable={true}
                    />
                  </div>
                </div>
                <div className="form-group col-md-6 col-lg-3">
                  <label htmlFor="">{I18n.t("js.show_tour.labels.meal")}</label>
                  <div style={divStyle}>
                    <Select
                      options={mealTypes}
                      placeholder={I18n.t("js.choose")}
                      value={selectedMealType}
                      onChange={(option) => {
                        setSelectedMealType(option);
                      }}
                      styles={customSelectStyles}
                      isClearable={true}
                    />
                  </div>
                </div>
                <div className="form-group col-md-6 col-lg-3">
                  <Configuration
                    rooms={props.rooms}
                    adults={props.adults}
                    children={props.children}
                    onAdultsChange={(value) => setAdults(value)}
                    onChildrenChange={(value) => setChildren(value)}
                    onRoomsChange={(value) => setRooms(value)}
                  />
                </div>
                <div className="form-group col-md-6 col-lg-3">
                  <input
                    name="total_price"
                    id="total_price"
                    type="checkbox"
                    checked={totalPrice}
                    onChange={() => setTotalPrice(!totalPrice)}
                  />
                  <label htmlFor="total_price">
                    {I18n.t("js.show_tour.labels.price")}
                  </label>
                </div>
                <div className="form-group col-md-6 col-lg-3">
                  <input
                    name="return_route"
                    id="return_route"
                    type="checkbox"
                    checked={returnRoute}
                    onChange={() => setReturnRoute(!returnRoute)}
                  />
                  <label htmlFor="return_route">
                    {I18n.t("js.show_tour.labels.airport")}
                  </label>
                </div>
              </div>
            </div>
          </form>
        </div>

        <SpinLoading show={!isLoad} />
        <div className="calculation-list">
          {nearestTerms.length > 0 ? (
            nearestTerms.map((term) => (
              <NearestTerm
                key={term.id}
                id={term.id}
                hotelPath={term.hotel_path}
                orderTermPath={term.order_term_path}
                price={term.price}
                dateLabel={term.date_label}
                routes={term.routes}
                meals={term.meals}
              />
            ))
          ) : (
            <div className="d-flex flex-column align-items-center">
              {isLoad && (
                <h3 className="title-h3">
                  <strong className="text-tertiary">
                    {I18n.t("js.show_tour.no_records")}
                  </strong>
                </h3>
              )}
            </div>
          )}

          {isLoad && (
            <div className="btn--wrap">
              {page > 1 && (
                <button
                  className="btn btn-default"
                  onClick={() => {
                    setPage(page - 1);
                    moveToTop();
                  }}
                >
                  {I18n.t("js.show_tour.labels.prev")}
                </button>
              )}
              {totalCount > 0 &&
                totalCount - 10 * page > 0 && ( // 10 number of records per page
                  <button
                    className="btn btn-primary"
                    onClick={() => {
                      setPage(page + 1);
                      moveToTop();
                    }}
                  >
                    {I18n.t("js.show_tour.labels.next")}
                  </button>
                )}
            </div>
          )}
        </div>
      </React.Fragment>
    </VisibilitySensor>
  );
};

const customSelectStyles = {
  control: (base, state) => ({
    ...base,
    borderRadius: 0,
    borderStyle: "none",
    marginTop: "1px",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: isDisabled
      ? null
      : isSelected
      ? "#2B4985"
      : isFocused
      ? styles.backgroundColor
      : null,
  }),
};

const divStyle = {
  color: "black",
};

HotelCalculationList.propTypes = {
  term_id: PropTypes.number.isRequired,
  hotel_id: PropTypes.number.isRequired,
  hotel_path: PropTypes.string.isRequired,
  product_slug: PropTypes.string.isRequired,
  hotel_slug: PropTypes.string.isRequired,
  adults: PropTypes.number,
  children: PropTypes.number,
  rooms: PropTypes.number,
  town_id: PropTypes.number,
  meal_type: PropTypes.any,
  total_price: PropTypes.bool,
  return_route: PropTypes.bool,
};

HotelCalculationList.defaultProps = {
  adults: 2,
  children: 0,
  rooms: 1,
  total_price: false,
  return_route: false,
};

export default HotelCalculationList;
